import { VIDEO_LOG_BASE_PATH } from "./videoLogs.ts";

interface VideoLogPlayerProps {
  title: string;
  file: string;
  onClose: () => void;
}

// Full-screen watch overlay for an unlocked "Uncovered Video Log" clip.
// Deliberately minimal — a backdrop, a native <video controls>, a close
// button. No custom playback chrome; the clips are short mood pieces, not a
// feature that needs scrubbing/quality controls beyond what <video> gives
// for free.
function VideoLogPlayer({ title, file, onClose }: VideoLogPlayerProps) {
  return (
    <div
      onClick={onClose}
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 4000,
        background: "rgba(0,0,0,0.88)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 14,
      }}
    >
      <div
        style={{
          color: "var(--ro-accent-bright)",
          letterSpacing: "0.15em",
          fontWeight: "bold",
        }}
      >
        {title}
      </div>
      <video
        src={`${VIDEO_LOG_BASE_PATH}${file}`}
        controls
        autoPlay
        onClick={(e) => e.stopPropagation()}
        style={{
          maxWidth: "min(90vw, 960px)",
          maxHeight: "75vh",
          border: "1px solid var(--ro-accent)",
          background: "black",
        }}
      />
      <button
        className="Button green"
        onClick={onClose}
        style={{ marginTop: 4 }}
      >
        CLOSE
      </button>
    </div>
  );
}

export default VideoLogPlayer;
